import { APPLICATION as application } from './application';
import { UI as ui } from './ui';
import { USER as user } from './user';

export const COMPONENTS = {
  application,
  user,
  ui
};
